import { Box } from '@mui/material'
import { ChannelsSearchResults } from './ChannelsSearchResults'
import { VodSearchResults } from './VodSearchResult'
import { usePopperSearchResultsLogic } from '@/shared/hooks'
import { ChannelType } from '@/shared/types/appTypes'

interface IPopperSearchResult {
    channels: ChannelType[]
    query: string
    onClick: () => void
}

export const PopperSearchResult = ({
    channels,
    query,
    onClick,
}: IPopperSearchResult) => {
    const {
        isShowMoreVod,
        isShowMoreTV,
        isShowMoreEpg,
        ref,
        setIsShowMoreVod,
        setIsShowMoreTV,
        setIsShowMoreEpg,
        finallyFiltered,
        channelsFuturePlaying,
        vodSearchResults,
        container,
    } = usePopperSearchResultsLogic(channels, query)

    return (
        <Box ref={ref} sx={container}>
            {finallyFiltered.length !== 0 &&
                !isShowMoreVod &&
                !isShowMoreEpg && (
                    <ChannelsSearchResults
                        channelsSet={finallyFiltered}
                        setShowMore={setIsShowMoreTV}
                        showMore={isShowMoreTV}
                        onItemClick={onClick}
                    />
                )}
            {vodSearchResults.length !== 0 &&
                !isShowMoreTV &&
                !isShowMoreEpg && (
                    <Box mt="16px">
                        <VodSearchResults
                            setShowMore={setIsShowMoreVod}
                            showMore={isShowMoreVod}
                            vodItemsSet={vodSearchResults}
                            onItemClick={onClick}
                        />
                    </Box>
                )}
            {channelsFuturePlaying.length !== 0 &&
                !isShowMoreTV &&
                !isShowMoreVod && (
                    <Box mt="16px">
                        <ChannelsSearchResults
                            channelsSet={channelsFuturePlaying}
                            setShowMore={setIsShowMoreEpg}
                            showMore={isShowMoreEpg}
                            onItemClick={onClick}
                        />
                    </Box>
                )}
        </Box>
    )
}
